import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Phases } from '../../../../../../../components/channel-details-controls/meter/phases';
import { PHASES_COLORS } from '../../../../../../../const';
import { SelectedPhase } from '../../../../../../../types';

type PhasesButtonGroupProps = {
  selectedPhases: number[];
  onSelectedPhases: (options: number[]) => void;
  defaultPhases: number[];
  readonly?: boolean;
  singleChoice?: boolean;
  className?: string;
  itemPrefix?: string;
};

export const PhasesButtonGroup: React.FC<PhasesButtonGroupProps> = ({
  onSelectedPhases,
  selectedPhases,
  defaultPhases,
  readonly = false,
  singleChoice = false,
  className,
  itemPrefix,
}) => {
  const { t } = useTranslation('channel-details');

  const mappedPhases: SelectedPhase[] = useMemo(() => {
    return defaultPhases?.map((phaseNumber) => {
      const label = !phaseNumber ? t('sumOfPhases') : `${itemPrefix ?? t('phase')} ${phaseNumber}`;
      return {
        value: phaseNumber,
        label,
        color: PHASES_COLORS[phaseNumber],
      };
    });
  }, [defaultPhases]);

  useEffect(() => {
    if (!selectedPhases.length && defaultPhases?.length) {
      onSelectedPhases([mappedPhases[0].value]);
    }
  }, [selectedPhases]);

  const setActivePhases = (value: number) => {
    if (singleChoice) {
      onSelectedPhases([value]);
    } else {
      if (value === 0) {
        onSelectedPhases([value]);
      } else {
        const isValue = selectedPhases.includes(value);
        if (!isValue) {
          onSelectedPhases([...selectedPhases.filter((phase) => phase !== 0), value]);
        } else if (isValue) {
          onSelectedPhases([...selectedPhases.filter((phase) => phase !== value)]);
        }
      }
    }
  };

  if (!defaultPhases || defaultPhases.length === 0) return null;

  return (
    <Phases
      mappedPhases={mappedPhases}
      selectedPhases={selectedPhases}
      className={className}
      onClickPhase={(val) => {
        if (!readonly) setActivePhases(val);
      }}
    />
  );
};
